<ob-master-layout>
	<ng-container obHeaderTitle>{{ "i18n.mmmi.header" | translate }}</ng-container>
	<ng-template #obHeaderControl><mmmi-login></mmmi-login></ng-template>
</ob-master-layout>
